// PO-enrichment display helpers, shared by every surface that renders the
// GET /api/war-room/po-enrichment envelope (BuildPoModal, POCreation) so the display rules can
// never drift between them.
//
// Owner, 2026-09-06 ("just need to add some data points"): lookups that returned nothing render
// a dash — never a zero-as-fact; counts over our own data (SFP units, cheated days) are true
// zeros and render as such.
export const dash = (v, fmt) => (v === null || v === undefined ? '—' : fmt(v));

export const fmtPromise = (e) => (e?.gvs1Day == null ? '—'
    : `${Math.round(e.gvs1Day)}% / ${Math.round(e.gvs2Day)}%`);
export const fmtVelocity = (v) => dash(v, (x) => `${Number(x).toFixed(1)}/d`);
export const fmtRank = (v) => dash(v, (x) => `#${Number(x).toLocaleString()}`);

// The envelope's fcs → FcPinMap's pin shape (stock layer only — these are purchasing views; what
// is where NOW is the question). FCs without coordinates go to the unknown list, never dropped.
export function fcPins(fcs) {
    const pins = [];
    const unknown = [];
    (fcs || []).forEach((f) => {
        const pin = { fc: f.fc, lat: f.lat, lng: f.lng, city: f.city, state: f.state,
            stockUnits: f.qty, inboundUnits: null, selected: false };
        if (f.lat != null && f.lng != null) pins.push(pin); else unknown.push(pin);
    });
    return { pins, unknown };
}

// Fetch enrichment for a (possibly >100) ASIN list in endpoint-sized chunks and merge.
// The endpoint caps at 100 ASINs per call; failure of any chunk degrades to dashes for its
// ASINs — enrichment is context, never a gate.
export async function fetchEnrichment(apiClient, asins) {
    const unique = [...new Set((asins || []).filter(Boolean))];
    const merged = {};
    for (let i = 0; i < unique.length; i += 100) {
        const chunk = unique.slice(i, i + 100);
        try {
            const res = await apiClient.get(`/api/war-room/po-enrichment?asins=${chunk.join(',')}`);
            Object.assign(merged, res.data?.enrichment || {});
        } catch (err) {
            console.error('PO enrichment chunk failed:', err);
        }
    }
    return merged;
}
